export const IMMEDIATE_NODE = 'imediato'
export const SCHEDULED_NODE = 'agendado'
export const NOSHOW_NODE = 'noshow'
export const ATTACHMENTS_NODE = 'anexos'
